import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from '../general-components/Button';
import styles from './EditUserPage.module.css';
import FormInput from '../general-components/FormInput';

const UserPasswordForm: React.FC<{
    handlePasswordChange: (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
    handlePasswordSubmit: Function;
    errorMsg: any;
}> = ({ handlePasswordChange, handlePasswordSubmit, errorMsg }) => {
    const { t } = useTranslation();
    return (
        <form className={styles.userPassword}>
            <h3>{t('userPage.userPasswordForm.title')}</h3>
            <FormInput
                label={t('userPage.userPasswordForm.form.oldPassword')}
                className={styles.userInput}
                type="password"
                onChange={handlePasswordChange}
                name="oldPassword"
                errorMsg={errorMsg.oldPassword}
            />
            <FormInput
                label={t('userPage.userPasswordForm.form.newPassword')}
                className={styles.userInput}
                type="password"
                onChange={handlePasswordChange}
                name="newPassword"
                errorMsg={errorMsg.newPassword}
            />
            <FormInput
                label={t('userPage.userPasswordForm.form.repeatNewPassword')}
                className={styles.userInput}
                type="password"
                onChange={handlePasswordChange}
                name="repeatNewPassword"
                errorMsg={errorMsg.repeatNewPassword}
            />
            <div className={styles.submitBtnField}>
                <Button
                    type={ButtonType.submit}
                    onClick={handlePasswordSubmit}
                    className={styles.submitBtn}
                >
                    {t('userPage.userPasswordForm.buttons.savePassword')}
                </Button>
            </div>
        </form>
    );
};

export default UserPasswordForm;
